import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export default function StandaloneDatePicker({onChangeHandler = () => {}, value}) {
	const { t } = useTranslation();
	const constantValueLabel = t("CONSTANT_VALUE");
	const [selectedDate, setSelectedDate] = useState(dayjs(value,"YYYY/MM/DD"));
    const [error, setError] = useState("");

    const changeHandler = (newDate) => {
        const changedDate = dayjs(newDate)?.format('YYYY/MM/DD')
        setSelectedDate(newDate);
        if(changedDate !== "Invalid Date") {
            onChangeHandler(changedDate);
            setError("");
        }
        else {
            setError(t("BOX_INVALID_DATE_FORMAT") + "(yyyy/mm/dd)")
        }
    }

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
                format="YYYY/MM/DD"
				label={constantValueLabel}
				value={selectedDate}
				onChange={changeHandler}
				renderInput={(params) => <TextField 
                        {...params} 
                        sx={{
                            "& .MuiInputBase-input": {
                              padding: "9.5px 14px", // Set custom height
                            }
                        }} 
                    />
                }
			/>
            {error ? <span className="error">{error}</span> : ""}
		</LocalizationProvider>
	);
}
